/**
 * Filters out featured products not valid for the given provinceCode.
 * This also rejects the product if the imageAlt property is empty.
 * @param {object} product
 * - @param {string} product.imageAlt The product image's alt text
 * - @param {string[]} product.provinces A list of provinces that this product is available in
 * @param {string} provinceCode - from Object.values(PROVINCES)
 * @returns {boolean} Whether or not the product is available in the specified province
 */
function isFeaturedProductApplicable(product, provinceCode) {
    return !!product.imageAlt
        && (!product.provinces?.length || product.provinces.includes(provinceCode));
}

export default isFeaturedProductApplicable;
